import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
// import { NormalRightarrowLine } from '@m-ui/icons'
import { Tabs } from 'm-ui';
import cs from 'classnames';
import less from './index.module.less';
import { useLocale } from 'locales/I18N';
import { LanguageType } from 'types/enum';

const { TabPane } = Tabs;

const HelpCenter: React.FC = () => {
    const { locale } = useLocale();
    // const intl = useIntl()
    const [activeTabKey, setActiveTabKey] = useState<string>('#/overlay1');
    const onTabChange = (key: string) => {
        setActiveTabKey(key);
    };

    return (
        <div className={less.container}>
            <Tabs
                tabPosition="left"
                // tabBarStyle={{ width: '240px' }}
                activeKey={activeTabKey}
                onTabClick={(key) => {
                    console.log(key);
                    onTabChange(key);
                    if (key === 'overlay1') {
                        const url =
                            locale === LanguageType.enUS
                                ? 'https://docs.qingque.cn/s/home/eZQCq137qZz98sS1GnHZqQZ3V?identityId=1oEElSWqQi3&section=1286527815'
                                : 'https://docs.qingque.cn/s/home/eZQBkzE5Nxu0E_5vmY3ItjksD?identityId=1oEElSWqQi3&section=1277920148';
                        window.open(url);
                    }
                    if (key === 'overlay2') {
                        const url =
                            locale === LanguageType.enUS
                                ? 'https://docs.qingque.cn/s/home/eZQC5o52VvqigYQ9uFsGrNH4z?identityId=1oEElSWqQi3'
                                : 'https://docs.qingque.cn/s/home/eZQC6__oen_krDzBGKdgRP_Ac?identityId=1oEElSWqQi3';
                        window.open(url);
                    }
                    if (key === 'overlay3') {
                        window.open('https://docs.qingque.cn/d/home/eZQAOwHvogbP5lSzuWxFtEbd2?identityId=1oEDkFyyAEe');
                    }
                    if (key === 'overlay4') {
                        window.open('https://docs.qingque.cn/d/home/eZQBeU-w53gDWk68fPLagO1lt?identityId=1oEDkFyyAEe');
                    }
                    if (key === 'overlay5') {
                        window.open('https://survey.corp.kuaishou.com/view/r50op1k2?');
                    }
                }}
            >
                <TabPane
                    tab={
                        <span className={cs(less.titleSpan, { [less.titleSpanActive]: activeTabKey === 'overlay1' })}>
                            <FormattedMessage defaultMessage="Product Library" />
                            {/* <NormalRightarrowLine className={less.titleSpanIcon} /> */}
                        </span>
                    }
                    key="overlay1"
                />
                <TabPane
                    tab={
                        <span className={cs(less.titleSpan, { [less.titleSpanActive]: activeTabKey === 'overlay2' })}>
                            <FormattedMessage defaultMessage="Video Guides" />
                            {/* <NormalRightarrowLine className={less.titleSpanIcon} /> */}
                        </span>
                    }
                    key="overlay2"
                />
                <TabPane
                    tab={
                        <span className={cs(less.titleSpan, { [less.titleSpanActive]: activeTabKey === 'overlay3' })}>
                            <FormattedMessage defaultMessage="Client System" />
                            {/* <NormalRightarrowLine className={less.titleSpanIcon} /> */}
                        </span>
                    }
                    key="overlay3"
                />
                <TabPane
                    tab={
                        <span className={cs(less.titleSpan, { [less.titleSpanActive]: activeTabKey === 'overlay4' })}>
                            <FormattedMessage defaultMessage="Supplier System" />
                            {/* <NormalRightarrowLine className={less.titleSpanIcon} /> */}
                        </span>
                    }
                    key="overlay4"
                />
                <TabPane
                    tab={
                        <span className={cs(less.titleSpan, { [less.titleSpanActive]: activeTabKey === 'overlay5' })}>
                            <FormattedMessage defaultMessage="Recruiting Supplier" />
                            {/* <NormalRightarrowLine className={less.titleSpanIcon} /> */}
                        </span>
                    }
                    key="overlay5"
                />
                {/* <TabPane
            tab={
                <a 
                    target='_blank' 
                    href="https://s1.kwai.net/kos/s101/nlav11187/website/_next/static/media/kwai-logo.687744d9.png" 
                    rel="noreferrer"
                    className={less.titleLink}
                >
                    <span className={cs(less.titleSpan, {[less.titleSpanActive]: activeTabKey==='#/overlay3'})}>
                        <span>title333</span>
                        <NormalRightarrowLine className={less.titleSpanIcon} />
                    </span>
                </a>
            }
            key='#/overlay3'
        /> */}
            </Tabs>
        </div>
    );
};

export default HelpCenter;
